import { LitElement } from 'lit'
import {
    EventTypeRequiresDetail,
    EventTypeDoesNotRequireDetail,
    EventTypesWithRequiredDetail,
    EventTypesWithoutRequiredDetail,
    PUEventInit,
    GetCustomEventType,
    ValidEventTypeMap,
} from '../events/event'

export default class CirkayElement extends LitElement {
    
    emit<T extends string & keyof EventTypesWithoutRequiredDetail>(
        name: EventTypeDoesNotRequireDetail<T>,
        options?: PUEventInit<T> | undefined
    ): GetCustomEventType<T>
    emit<T extends string & keyof EventTypesWithRequiredDetail>(
        name: EventTypeRequiresDetail<T>,
        options: PUEventInit<T>
    ): GetCustomEventType<T>
    emit<T extends string & keyof ValidEventTypeMap>(
        name: T,
        options?: PUEventInit<T> | undefined
    ): GetCustomEventType<T> {
        const event = new CustomEvent(name, {
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {},
            ...options
        })

        this.dispatchEvent(event)

        return event as GetCustomEventType<T>
    }

    static define(name: string, elementConstructor = this, options: ElementDefinitionOptions = {}) {

        const currentlyRegisteredConstructor = customElements.get(name) as
            | CustomElementConstructor
            | typeof CirkayElement

        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options)
            } catch (_err) {
                console.error(name, _err)
                customElements.define(name, class extends elementConstructor { }, options)
            }
            return
        }
    }

    static dependencies: Record<string, typeof CirkayElement> = {}

    constructor() {
        super()
        Object.entries((this.constructor as typeof CirkayElement).dependencies).forEach(([name, component]) => {
            (this.constructor as typeof CirkayElement).define(name, component)
        })
    }
}
